export default "__VITE_ASSET__DjG76Ss___"